import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e771f25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-x3 py-50 bg-white h-full lg:h-auto lg:pb-60 xl:px-x8 xl:py-50" }
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: _ctx.activeMainNavigationId,
      ref: "mainNavigationWrapper",
      class: "main-navigation-wrapper flex flex-col main-navigation-wrapper--overflow-enabled"
    }, [
      _createVNode(_Transition, {
        appear: "",
        "enter-active-class": "o-anim-main-nav-enter",
        "leave-active-class": "o-anim-main-nav-leave",
        mode: "out-in",
        onEnter: _ctx.enter,
        onAfterEnter: _ctx.afterEnter,
        onBeforeLeave: _ctx.beforeLeave
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", {
            key: _ctx.activeMainNavigationTransitionKey,
            ref: "mainNavigation",
            class: "flex flex-col flex-1 min-h-0 lg:h-auto"
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.mainNavigationComponent)))
          ]))
        ]),
        _: 1
      }, 8, ["onEnter", "onAfterEnter", "onBeforeLeave"])
    ], 8, _hoisted_2)
  ]))
}